import { jsx } from '@emotion/core'; // @ts-ignore
// eslint-disable-next-line @typescript-eslint/camelcase

import { checkmark_16, arrowDown_16, arrowUp_16 } from '@trustpilot/icons';
import { StyledItem, StyledIcon, StyledPanel } from './styled';
import { DateUtils } from 'react-day-picker';
import * as DateRangePickerPresets from './DateRangePickerPresets';
import { Button as FilterButton } from '../button';
import Dropdown from './presetDropdown';
import { useToggle } from '../../../shared';

var isPresetSelected = function isPresetSelected(selectedRange, presetRange) {
  if (!selectedRange.startDate || !selectedRange.endDate || !presetRange.startDate || !presetRange.endDate) {
    return false;
  } else {
    return DateUtils.isSameDay(selectedRange.startDate, presetRange.startDate) && DateUtils.isSameDay(selectedRange.endDate, presetRange.endDate);
  }
};

var isCustomRangeSelected = function isCustomRangeSelected(selectedRange, presets) {
  return presets.reduce(function (isCustomRange, preset) {
    return isCustomRange && !isPresetSelected(selectedRange, preset);
  }, true) && (!!selectedRange.startDate || !!selectedRange.endDate);
};

var Item = function Item(_a) {
  var _b = _a.checked,
      checked = _b === void 0 ? false : _b,
      children = _a.children,
      onClick = _a.onClick;
  /* eslint-disable @typescript-eslint/camelcase */

  return jsx(StyledItem, {
    onClick: onClick,
    active: checked
  }, jsx(StyledIcon, {
    checked: checked,
    content: checkmark_16
  }), children);
  /* eslint-enable */
};
/* eslint-disable @typescript-eslint/camelcase */


var DropdownHandle = function DropdownHandle(_a) {
  var toggled = _a.toggled,
      toggle = _a.toggle,
      title = _a.title,
      id = _a.id;
  return jsx(FilterButton, {
    icon: toggled ? arrowUp_16 : arrowDown_16,
    onClick: toggle,
    active: toggled,
    id: id
  }, title);
};

export var PresetSelector = function PresetSelector(_a) {
  var selectedRange = _a.selectedRange,
      presets = _a.presets,
      _onClick = _a.onClick,
      _b = _a.compact,
      compact = _b === void 0 ? false : _b,
      strings = _a.strings;

  if (!presets.length) {
    presets = [DateRangePickerPresets.fourWeeks(strings.defaults.fourWeeks), DateRangePickerPresets.threeMonths(strings.defaults.threeMonths), DateRangePickerPresets.sixMonths(strings.defaults.sixMonths), DateRangePickerPresets.year(strings.defaults.year)];
  }

  var placeholder = strings.placeholder;

  var _c = useToggle(false),
      toggled = _c[0],
      toggle = _c[1];

  function handleClickOutside() {
    if (toggled) {
      toggle();
    }
  }

  function renderCompactTitle() {
    var selectedPreset = presets.find(function (preset) {
      return isPresetSelected(selectedRange, preset);
    });
    if (selectedPreset) return selectedPreset.label;
    return placeholder;
  }

  if (!presets || presets.length === 0) {
    return null;
  }

  if (compact) {
    return jsx(Dropdown, {
      handle: jsx(DropdownHandle, {
        toggled: toggled,
        toggle: toggle,
        title: renderCompactTitle(),
        id: 'preset_id'
      }),
      done: strings.done,
      toggled: toggled,
      onOutsideClick: handleClickOutside
    }, presets.map(function (preset) {
      return jsx(Item, {
        key: preset.label,
        checked: isPresetSelected(selectedRange, preset),
        onClick: function onClick() {
          return _onClick(preset);
        }
      }, preset.label);
    }));
  }

  return jsx(StyledPanel, null, jsx(Item, {
    key: placeholder,
    checked: isCustomRangeSelected(selectedRange, presets),
    onClick: function onClick() {
      return null;
    }
  }, placeholder), presets.map(function (preset) {
    return jsx(Item, {
      key: preset.label,
      checked: isPresetSelected(selectedRange, preset),
      onClick: function onClick() {
        return _onClick(preset);
      }
    }, preset.label);
  }));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Header/filters/daterange/presetSelector.js
// module id = 1033
// module chunks = 0